"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UploadImageButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const store_1 = require("../../store");
const document_1 = require("../../slices/document");
const UploadControl_1 = __importDefault(require("./UploadControl"));
const document_2 = require("../../services/document");
const constants_1 = require("../../common/constants");
const AppTooltip_1 = __importDefault(require("../AppTooltip"));
function UploadImageButton({ document, style, ...restProps }) {
    const dispatch = (0, store_1.useAppDispatch)();
    const { request } = (0, useRequest_1.default)();
    const handleUploadImage = (0, react_1.useCallback)((file) => {
        dispatch((0, document_1.setIsImageRegenerating)(true));
        request(document_2.uploadImage, file, document).then((imageResponse) => {
            if (imageResponse) {
                dispatch((0, document_1.patchDocumentCharacter)({
                    id: document.character_id,
                    changes: {
                        documentImage: imageResponse.urls[imageResponse.urls.length - 1],
                    },
                }));
            }
            dispatch((0, document_1.setIsImageRegenerating)(false));
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(UploadControl_1.default, { fileType: ['image/gif', 'image/jpeg', 'image/png'], invalidTypeMessage: constants_1.WRONG_IMAGE_FILE_TYPE_MESSAGE, fileAction: handleUploadImage, children: (0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: "Upload Image", children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: typeof style === 'function'
                    ? (state) => [styles.button, style(state)]
                    : [styles.button, style], ...restProps, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faImage, size: 16, color: 'white' }) }) }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    button: {
        backgroundColor: '#00000066',
        padding: 8,
        borderRadius: 16,
    },
});
